import { cn } from 'utils/styling';

const Image = ({ className, ...props }) => {
    return <img className={cn('object-contain', className)} {...props} />;
};

export default Image;
